import
  React, {
  useEffect
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  Base,
  JourneyProvider,
  TextButton
} from '@vodacom/web-common';

import {
  PropTypes
} from 'prop-types';

import
  dayjs
from 'dayjs';

import {
  Accordion,
  PrimaryButton
} from 'components';

import {
  TwitterContent,
  TwitterHeader
} from '.';

import {
  TrendsProvider
} from '../providers';

import {
  CacheKeys,
  ErrorKeys,
  OriginContexts
} from '../../../constants';

import {
  HandleRender
} from 'hocs';

import {
  isEqual,
  useRedirectHandler
} from 'helpers';

const relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);

export const Trends = props => {

  const history = useHistory();

  const [
    state,
    setState
  ] = React.useState({
    trends: [],
    tweets: {},
    numberOfTrends: props.numberOfTrends || 5,
    numberOfTweets: 3,
    error: null,
    loading: true,
    showTrendsButton: props.showTrendsButton,
    showTweetsButton: true
  });

  const [
    accordionState,
    setAccordionState
  ] = React.useState({
    activeAccordionIndex: -1
  });

  const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value');

  const mountedRef = React.useRef(true);
  const redirectHandler = useRedirectHandler();

  const formatDate = date => {

    let time = dayjs(date).fromNow();

    return time;
  };

  const expandAccordion = async (trend, index) => {

    let tweets = state.tweets;

    setAccordionState(prevState => ({
      ...prevState,
      activeAccordionIndex: (index !== prevState.activeAccordionIndex) ? index : -1
    }));

    tweets[trend] = await getTweets(trend);

    setState(prevState => ({
      ...prevState,
      numberOfTweets: 3,
      showTweetsButton: true,
      tweets: tweets
    }));
  };

  const buildTwitterAccordion = () => {

    let twitterAccordions = [];

    if (!state.trends?.length > 0) {

      return twitterAccordions;
    }

    let trends = state.trends;

    if (!trends || !Array.isArray(trends)) {

      return twitterAccordions;
    }

    trends.forEach((trend, index) => {

      if (index >= state.numberOfTrends) {

        return;
      }

      let tweetContent = state.tweets?.[trend.query];

      if (!trend?.name || !trend?.tweet_volume || !trend?.query) {

        return;
      }

      let tweetList = [];

      if (tweetContent && Array.isArray(tweetContent) && tweetContent.length > 0) {

        tweetContent.forEach((tweet, index) => {

          if (index >= state.numberOfTweets) {

            return;
          }

          tweetList.push(

            <TwitterContent
              key={`${tweet?.id}--${index}`}
              contentAccount={tweet?.user?.name}
              contentUsername={tweet?.user?.username}
              contentTweet={tweet?.text}
              contentLikes={tweet?.public_metrics?.like_count}
              contentRetweets={tweet?.public_metrics?.retweet_count}
              contentDate={formatDate(tweet?.created_at)} />
          );
        });

        if (state.showTweetsButton) {

          tweetList.push(

            <TextButton
              key={`seeMoreTweetsButton--${index}`}
              margin={'0 auto'}
              width='auto'
              height={'40px'}
              padding={'10px 16px'}
              onClick={() => {

                setState(prevState => ({
                  ...prevState,
                  numberOfTweets:
                    (prevState.numberOfTrends + 2 <= 10) ?
                      prevState.numberOfTrends + 2 :
                      prevState.numberOfTrends + (10 - prevState.numberOfTrends),
                  showTweetsButton: false
                }));
              }}>

              {'See more'}
            </TextButton>
          );
        }

        if (!state.showTweetsButton && !isEqual(context, OriginContexts.VodaPay)) {

          tweetList.push(

            <TextButton
              key={`seeMoreTweetsButton--${index}`}
              margin={'0 auto'}
              width='auto'
              height={'40px'}
              padding={'10px 16px'}
              onClick={() => {

                redirectHandler(
                  history.location,
                  `/redirect?targetUrl=https://twitter.com/search?q=${trend?.name}&isZeroRated=false`,
                  false
                );
              }}>

              {'See more on Twitter'}
            </TextButton>
          );
        }
      }

      if (tweetContent?.ok === false) {

        tweetList.push(

          <React.Fragment key={`RefreshTweet--${index}`}>

            <TextButton
              margin={'0 auto'}
              width='auto'
              height={'40px'}
              padding={'10px 16px'}
              onClick={ async () => {

                let tweets = state?.tweets;
                tweets[trend?.query] = await getTweets(trend?.query);
                setState(prevState => ({
                  ...prevState,
                  numberOfTweets: 3,
                  showTweetsButton: true,
                  tweets: tweets
                }));

              }}>

              {'Error, please try again'}
            </TextButton>
          </React.Fragment>
        );
      }

      let twitterContent = <Base>{tweetList}</Base>;

      let twitterHeader = <TwitterHeader title={trend?.name} subtitle={trend?.tweet_volume}/>;
      twitterAccordions.push(

        <Accordion
          key={`${trend.name}--${index}`}
          header={twitterHeader}
          content={(tweetList.length > 0 && twitterContent) || null}
          isOpen={index === accordionState.activeAccordionIndex}
          onAccordionClick={() => expandAccordion(trend.query, index)} />
      );
    });

    twitterAccordions.push(

      <Base
        key={'seeMoreTrendsBase'}
        display={'flex'}
        justifyContent={'center'}
        margin={'0 0 0'}>

        { state.showTrendsButton ?

          <PrimaryButton
            margin={'16px 0'}
            text={'View more'}
            fontSize={'14px'}
            onClick={() => {

              setState(prevState => ({
                ...prevState,
                numberOfTrends:
                  (prevState.numberOfTrends + 5 <= 10) ?
                    prevState.numberOfTrends + 5 :
                    prevState.numberOfTrends + (10 - prevState.numberOfTrends),
                showTrendsButton: false
              }));
            }}/>

          : <Base
              margin={'16px auto'} />
        }
      </Base>
    );

    return twitterAccordions;
  };

  const getTweets = async (trend) => {

    const tweets = await TrendsProvider.getCachedItem(`tweets--${trend}`, null, () => TrendsProvider.getTweets(trend));
    return tweets?.result;
  };

  useEffect(() => {

    const getTrends = async () => {

      const trends = await TrendsProvider.getCachedItem('trends', null, TrendsProvider.getTrends);

      if (!mountedRef.current) {
        return;
      }

      if (!trends?.ok) {

        setState(prevState => ({
          ...prevState,
          error: trends?.error,
          loading: false
        }));

        return;
      }

      let usableTrends = trends?.result
        ?.filter(
          trend => trend?.tweet_volume !== null
        );

      usableTrends
        ?.sort((a, b) => {
          return b.tweet_volume - a.tweet_volume;
        });

      setState(prevState => ({
        ...prevState,
        trends: usableTrends,
        loading: false
      }));

      return;
    };

    getTrends();

    return () => {
      mountedRef.current = false;
    };

  }, []);

  return (

    <HandleRender
      isLoading={state.loading}
      isError={state.error}
      error={{ type: ErrorKeys.General, title: 'Trends' }}>

      {buildTwitterAccordion()}
    </HandleRender>
  );
};

Trends.propTypes = {
  showTrendsButton: PropTypes.bool
};

Trends.defaultProps = {
  showTrendsButton: true
};